import type { CustomQueryPageParams, QueryPageReturnType } from '@luna/api';
import type { ExportSetDefinitionDto } from '@api-client/export-center';

import { fetchMetadataExportsSets } from './fetchMetadataExportsSets';

interface SearchParams {
    name?: string;
}

type Response = QueryPageReturnType<ExportSetDefinitionDto>;

export const queryExportSetsPage = ({
    pageNumber = 0,
    ...params
}: CustomQueryPageParams<SearchParams>): Promise<Response> =>
    fetchMetadataExportsSets({ page: pageNumber, ...params }).then(
        ({ items, page: { currentPage, totalPages, ...pageMetadata } }) => ({
            data: items,
            pageNumber: currentPage,
            pageCount: totalPages,
            ...pageMetadata,
        }),
    );
